<template>
  <v-data-table
    class="sponsor-table"
    :headers="headers"
    :items="items"
    :loading="loading"
    :options.sync="options"
    :footer-props="{
      itemsPerPageOptions: [5, -1]
    }"
    no-data-text="No reasons available"
  >
    <template #item="{ item }">
      <tr>
        <td>
          <span v-if="!item.showMore && item.description.length > descriptionLimit">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="item.shortDescription"></span>
          </span>
          <span v-else>
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="item.description"></span>
          </span>
          <span
            v-show="item.description.length > descriptionLimit"
            class="link"
            @click="toggleShowMore(item)"
            >Show {{ item.showMore ? 'Less' : 'More' }}</span
          >
        </td>
        <td>{{ item.type }}</td>
        <td class="text-right">{{ item.count }}</td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import { MyActiveOrganization } from '@/helpers/my-account-helper'
import trialSummaryService from '@/services/trial-summary-service'
import _ from 'lodash'

export default {
  props: {
    trialId: { type: String, default: null }
  },
  data() {
    return {
      descriptionLimit: 90,
      headers: [
        {
          text: 'Criteria Not Met',
          sortable: true,
          value: 'description'
        },
        {
          text: 'Type',
          sortable: true,
          value: 'type'
        },
        {
          text: 'Count',
          sortable: true,
          value: 'count',
          align: 'right'
        }
      ],
      options: {
        page: 1,
        sortBy: ['count'],
        sortDesc: [true],
        itemsPerPage: 5
      },
      items: [],
      loading: true
    }
  },
  computed: {
    orgId() {
      return MyActiveOrganization.id
    }
  },
  watch: {
    async trialId() {
      await this.getNotEligibleCounts()
    }
  },
  created() {
    this.getNotEligibleCounts()
  },
  methods: {
    async getNotEligibleCounts() {
      this.loading = true
      const data = (
        await trialSummaryService.getNotEligibleCounts({
          orgId: this.orgId,
          trialId: this.trialId
        })
      ).data
      const vm = this
      this.items = _(data)
        .map(it => ({
          type: _.capitalize(it.trialEligibility.eligibilityStatus),
          description: it.trialEligibility.description,
          count: it.count
        }))
        .groupBy(it => `${it.type}/${it.description}`)
        .map(value => ({
          type: value[0].type,
          description: value[0].description,
          count: _.sumBy(value, 'count'),
          showMore: false,
          shortDescription: _.truncate(value[0].description, { length: vm.descriptionLimit })
        }))
        .value()
      this.loading = false
    },
    toggleShowMore(item) {
      item.showMore = !item.showMore
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  color: var(--v-anchor-base);
  cursor: pointer;
}
</style>
